import { Grid, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const EditChecklistIcon = () => {
  const [isShown, setIsShown] = React.useState(false);
  const { t } = useTranslation();
  return (
    <>
      <Tooltip title={t("dataTableEdit")}>
        <Grid
          onMouseEnter={() => setIsShown(true)}
          onMouseLeave={() => setIsShown(false)}
        >
          {isShown ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
              <path id="Edit" d="M3,18.021V13.776a1,1,0,0,1,.29-.711l2.353-2.343h0l7.009-7.009h0L14.464,1.9a3,3,0,0,1,4.245,0l1.412,1.412a3,3,0,0,1,0,4.245L9.008,18.732a1,1,0,0,1-.711.29H4A1,1,0,0,1,3,18.021ZM7.786,11.4l2.834,2.834L16.207,8.65,13.373,5.816Zm8.13-8.13L14.795,4.394l2.834,2.834L18.75,6.106a1,1,0,0,0,0-1.412L17.328,3.273A1,1,0,0,0,15.916,3.273ZM5,17.02H7.836L9.2,15.658,6.364,12.825,5,14.187Z" transform="translate(-3 -1.023)" fill="#6b6e71" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
              <path id="Edit" d="M3,18.021V13.776a1,1,0,0,1,.29-.711l2.353-2.343h0l7.009-7.009h0L14.464,1.9a3,3,0,0,1,4.245,0l1.412,1.412a3,3,0,0,1,0,4.245L9.008,18.732a1,1,0,0,1-.711.29H4A1,1,0,0,1,3,18.021ZM7.786,11.4l2.834,2.834L16.207,8.65,13.373,5.816Zm8.13-8.13L14.795,4.394l2.834,2.834L18.75,6.106a1,1,0,0,0,0-1.412L17.328,3.273A1,1,0,0,0,15.916,3.273ZM5,17.02H7.836L9.2,15.658,6.364,12.825,5,14.187Z" transform="translate(-3 -1.023)" fill="#6b6e71" />
            </svg>
          )}
        </Grid>
      </Tooltip>
    </>
  );
};
export default EditChecklistIcon;
